import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h1>Ups, esta página no existe</h1>
      <Link to="dashboard" style={{ fontSize: "1.4rem" }}>
        Volver al inicio
      </Link>
    </div>
  );
};

export default NotFound;
